<template>
  <div class="input-box-holder star-container flex">
    <div
      class="star"
      v-for="star in 5"
      :key="star"
      @click="emit(star)"
    >
      <img class="icon icon--star-empty"
           src="@/assets/svg/star-default.svg">
      <img
        class="icon icon--star-fill"
        v-show="star <= value"
        src="@/assets/svg/star-selected.svg">
    </div>
  </div>
</template>

<script>
export default {
  name: 'Stars',
  props: ['value', 'errors', 'disable'],
  methods: {
    emit(star) {
      if (!this.disable) {
        this.$emit('input', star);
      }
    },
  },
};
</script>
